import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';

import { useSetLanguagePathname } from 'js/hooks/language/hooks/useSetLanguagePathname';

export const useNormalizeUrl = () => {
    const { pathLang } = useParams<{ pathLang: string }>();
    const lang = useUserSelector(prop('lang'));
    const setLanguagePathname = useSetLanguagePathname();

    useEffect(() => {
        if (!pathLang && lang) {
            setLanguagePathname(lang, true);
        }
    }, [pathLang, lang, setLanguagePathname]);
};
